{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Hai superato il limite di conversazioni. Il piano Hacker consente solo 500 conversazioni.",
      "INBOXES": "Hai superato il limite di caselle. Il piano Hacker supporta solo la live-chat del sito web. Caselle aggiuntive come email, WhatsApp ecc. richiedono un piano a pagamento.",
      "AGENTS": "Hai superato il limite di agenti. Il piano Hacker consente solo 2 agenti.",
      "NON_ADMIN": "Contatta il tuo amministratore per aggiornare il piano e continuare a utilizzare tutte le funzionalità."
    },
    "TITLE": "Impostazioni account",
    "SUBMIT": "Aggiorna le impostazioni",
    "BACK": "Indietro",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Impossibile aggiornare le impostazioni, riprova!",
      "SUCCESS": "Impostazioni account aggiornate con successo"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Elimina il tuo account",
      "NOTE": "Una volta eliminato il tuo account, tutti i tuoi dati saranno eliminati.",
      "BUTTON_TEXT": "Elimina il tuo account",
      "CONFIRM": {
        "TITLE": "Elimina account",
        "MESSAGE": "L'eliminazione del tuo account è irreversibile. Inserisci il nome del tuo account qui sotto per confermare che desideri eliminarlo definitivamente.",
        "BUTTON_TEXT": "Elimina",
        "DISMISS": "Annulla",
        "PLACE_HOLDER": "Digita {accountName} per confermare"
      },
      "SUCCESS": "Account contrassegnato per l'eliminazione",
      "FAILURE": "Impossibile eliminare l'account, riprova!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account programmato per l'eliminazione",
        "MESSAGE_MANUAL": "Questo account è programmato per l'eliminazione il {deletionDate}. È stato richiesto da un amministratore. Puoi annullare l'eliminazione prima di questa data.",
        "MESSAGE_INACTIVITY": "Questo account è programmato per l'eliminazione il {deletionDate} a causa di inattività dell'account. Puoi annullare l'eliminazione prima di questa data.",
        "CLEAR_BUTTON": "Annulla eliminazione programmata"
      }
    },
    "FORM": {
      "ERROR": "Correggi gli errori del modulo",
      "GENERAL_SECTION": {
        "TITLE": "Impostazioni generali",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID Account",
        "NOTE": "Questo ID è richiesto se si sta costruendo un'integrazione basata su API"
      },
      "NAME": {
        "LABEL": "Nome account",
        "PLACEHOLDER": "Nome del tuo account",
        "ERROR": "Inserisci un nome account valido"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Nome del tuo account",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Dominio email in entrata",
        "PLACEHOLDER": "Il dominio in cui riceverai le email",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email di supporto",
        "PLACEHOLDER": "Email di supporto della tua azienda",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Numero di giorni dopo che un ticket dovrebbe risolvere automaticamente se non c'è attività",
        "NOTE": "Numero di ore di inattività dopo le quali qualsiasi conversazione aperta sarà risolta automaticamente.",
        "PLACEHOLDER": "30",
        "ERROR": "Inserisci una durata di risoluzione automatica valida (minimo 1 giorno e massimo 999 giorni)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Numero di giorni dopo i quali una conversazione vuota deve risolversi automaticamente in assenza di attività",
        "PLACEHOLDER": "mai",
        "ERROR": "Inserisci una durata di auto-risoluzione vuota valida (minimo 1 giorno e massimo 999 giorni)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "La continuità della conversazione con le email è abilitata per il tuo account.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Puoi ricevere email nel tuo dominio personalizzato ora."
      },
      "PHONE": {
        "TITLE": "Impostazioni PBX",
        "NOTE": "Configura la connessione al tuo PBX per le chiamate telefoniche",
        "SIP_HOST": {
          "LABEL": "Dominio SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Modalità di composizione",
          "MODES": {
            "direct": "Diretta - la chiamata viene composta immediatamente al click sul link telefonico",
            "indirect": "Indiretta - il numero di telefono viene preparato nella casella di inserimento del widget telefonico"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Accesso alle registrazioni delle chiamate",
          "MODES": {
            "admin_only": "Solo amministratori",
            "admin_and_assigned_agent": "Amministratori e agente assegnato",
            "inbox_members": "Tutti gli agenti con accesso alla casella"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Impostazioni email",
        "NOTE": "Modifica il comportamento delle caselle email"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Modalità di visualizzazione della data della conversazione",
        "MODES": {
          "both": "Creazione e ultima attività",
          "last_activity_only": "Solo ultima attività",
          "last_customer_message": "Ultimo messaggio del cliente"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blocca domini con bassa reputazione"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Includi messaggio originale nella risposta all'email"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Risolvi automaticamente una nuova conversazione"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Sposta automaticamente una nuova conversazione e-mail nella casella del robot che ha elaborato gli ordini del contatto"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Etichette estese - Consenti nomi di etichette più lunghi con interfaccia popup più grande"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Assegna automaticamente la conversazione all'agente che ha creato l'ultima risposta"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Modalità notifiche push",
        "MODES": {
          "all_inboxes": "Tutte le caselle - Invia notifiche per tutti i tipi di canale",
          "chat_only": "Solo chat - Invia notifiche solo per canali non email"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Consenti di attivare/disattivare la firma nei messaggi inviati"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Mostra stato chat degli agenti sul wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Mostra nomi completi degli allegati senza troncamento"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Login con password",
        "MODES": {
          "allowed_for_all": "Consentito a tutti gli utenti",
          "allowed_for_agents_only": "Consentito solo agli agenti (gli amministratori devono usare OAuth)",
          "password_login_disabled": "Disabilitato - Solo OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "È disponibile una nuova versione. Ricarica per ottenere gli ultimi aggiornamenti.",
    "RELOAD_NOW": "Aggiorna ora",
    "LEARN_MORE": "Scopri di più",
    "PAYMENT_PENDING": "Il tuo pagamento è in sospeso. Aggiorna i tuoi dati di pagamento per continuare a usare questo software",
    "LIMITS_UPGRADE": "Il tuo account ha superato i limiti di utilizzo, aggiorna il tuo piano per continuare a usare questo software",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Premi Invio per selezionare",
      "ENTER_TO_REMOVE": "Premi Invio per rimuovere",
      "NO_OPTIONS": "L'elenco è vuoto",
      "NO_RESULT": "Nessun risultato trovato",
      "SELECT_ONE": "Selezionane uno",
      "SELECT": "Seleziona"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifiche",
    "MARK_ALL_DONE": "Contrassegna tutto come fatto",
    "DELETE_TITLE": "eliminato",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Notifiche non lette",
      "ALL_NOTIFICATIONS": "Visualizza tutte le notifiche",
      "LOADING_UNREAD_MESSAGE": "Caricamento notifiche non lette...",
      "EMPTY_MESSAGE": "Non hai notifiche non lette"
    },
    "LIST": {
      "404": "Nessuna notifica",
      "LOADING_MESSAGE": "Caricamento notifiche...",
      "TABLE_HEADER": [
        "Nome",
        "Numero di telefono",
        "Conversazioni",
        "Ultimo contattato"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nuova conversazione",
      "conversation_assignment": "Conversazione assegnata",
      "assigned_conversation_new_message": "Nuovo messaggio",
      "participating_conversation_new_message": "Nuovo messaggio",
      "conversation_mention": "Menzione",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Aggiorna"
    },
    "CONNECTION_LOST": {
      "TITLE": "Connessione persa",
      "DESCRIPTION": "Impossibile raggiungere il server. Controlla la connessione e riprova.",
      "RETRY": "Riprova"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Cerca o salta a",
    "SECTIONS": {
      "GENERAL": "Generale",
      "REPORTS": "Rapporti",
      "CONVERSATION": "Conversazioni",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Cambia assegnatario",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Cambia Team",
      "SNOOZE_CONVERSATION": "Posticipa conversazione",
      "EXECUTE_MACRO": "Esegui macro",
      "ADD_LABEL": "Aggiungi etichetta alla conversazione",
      "REMOVE_LABEL": "Rimuovi etichetta dalla conversazione",
      "SETTINGS": "Impostazioni",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Vai alla dashboard Conversazioni",
      "GO_TO_CONTACTS_DASHBOARD": "Vai alla dashboard Contatti",
      "GO_TO_REPORTS_OVERVIEW": "Vai alla panoramica dei report",
      "GO_TO_CONVERSATION_REPORTS": "Vai ai report della conversazione",
      "GO_TO_AGENT_REPORTS": "Vai ai report degli agenti",
      "GO_TO_LABEL_REPORTS": "Vai ai report delle etichette",
      "GO_TO_INBOX_REPORTS": "Vai ai report delle caselle",
      "GO_TO_TEAM_REPORTS": "Vai ai report dei team",
      "GO_TO_SETTINGS_AGENTS": "Vai alle impostazioni dell'agente",
      "GO_TO_SETTINGS_TEAMS": "Vai alle impostazioni del team",
      "GO_TO_SETTINGS_INBOXES": "Vai alle impostazioni delle caselle",
      "GO_TO_SETTINGS_LABELS": "Vai alle impostazioni delle etichette",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Vai alle impostazioni delle risposte predefinite",
      "GO_TO_SETTINGS_APPLICATIONS": "Vai alle impostazioni dell'applicazione",
      "GO_TO_SETTINGS_ACCOUNT": "Vai alle impostazioni dell'account",
      "GO_TO_SETTINGS_PROFILE": "Vai alle impostazioni del profilo",
      "GO_TO_NOTIFICATIONS": "Vai alle notifiche",
      "ADD_LABELS_TO_CONVERSATION": "Aggiungi etichetta alla conversazione",
      "ASSIGN_AN_AGENT": "Assegna un agente",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assegna un team",
      "EXECUTE_A_MACRO": "Esegui una macro",
      "MUTE_CONVERSATION": "Silenzia conversazione",
      "UNMUTE_CONVERSATION": "Riattiva conversazione",
      "REMOVE_LABEL_FROM_CONVERSATION": "Rimuovi etichetta dalla conversazione",
      "REOPEN_CONVERSATION": "Riapri la conversazione",
      "RESOLVE_CONVERSATION": "Risolvi la conversazione",
      "SEND_TRANSCRIPT": "Invia una trascrizione email",
      "SNOOZE_CONVERSATION": "Posticipa conversazione",
      "UNTIL_NEXT_REPLY": "Fino alla prossima risposta",
      "UNTIL_NEXT_WEEK": "Fino alla prossima settimana",
      "UNTIL_TOMORROW": "Fino a domani",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "clicca qui"
  }
}
